/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IndustryExpertise
 */
export interface IndustryExpertise {
    /**
     * 
     * @type {string}
     * @memberof IndustryExpertise
     */
    businessSectorHumanId: string;
    /**
     * 
     * @type {string}
     * @memberof IndustryExpertise
     */
    businessIndustryHumanId: string;
}

/**
 * Check if a given object implements the IndustryExpertise interface.
 */
export function instanceOfIndustryExpertise(value: object): value is IndustryExpertise {
    if (!('businessSectorHumanId' in value) || value['businessSectorHumanId'] === undefined) return false;
    if (!('businessIndustryHumanId' in value) || value['businessIndustryHumanId'] === undefined) return false;
    return true;
}

export function IndustryExpertiseFromJSON(json: any): IndustryExpertise {
    return IndustryExpertiseFromJSONTyped(json, false);
}

export function IndustryExpertiseFromJSONTyped(json: any, ignoreDiscriminator: boolean): IndustryExpertise {
    if (json == null) {
        return json;
    }
    return {
        
        'businessSectorHumanId': json['businessSectorHumanId'],
        'businessIndustryHumanId': json['businessIndustryHumanId'],
    };
}

export function IndustryExpertiseToJSON(value?: IndustryExpertise | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'businessSectorHumanId': value['businessSectorHumanId'],
        'businessIndustryHumanId': value['businessIndustryHumanId'],
    };
}

